import EfSwiperTab from '@elem/ui/ef-swiper-tab';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';

export default function TheComp() {
    const { t } = useLang('rapid.TabB');
    const { locale } = useRouter();
    const props = {
        theme: 'white',
        loop: true,
        navigation: true,
        pagination: false,
        gap: 0,
        lists: [
            {
                tab: t('a_tab'),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1729597445381/pc2.jpg',
                pad: 'https://websiteoss.ecoflow.com/upload/image/1729597445381/pc2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1729597445810/m2.jpg',
                title: t('a_tab'),
                desc: t.rich('a_desc', {
                    sup: (text: string) => <sup className="sup">{text}</sup>,
                }),
            },
            {
                tab: t('b_tab'),
                pc:
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1730686416818/pc_Anti-slip%20magnetism.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1729597445590/pc1.jpg',
                pad:
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1730686416818/pc_Anti-slip%20magnetism.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1729597445590/pc1.jpg',
                h5:
                    locale === 'jp'
                        ? 'https://websiteoss.ecoflow.com/upload/image/1730686416479/m_Anti-slip%20magnetism.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1729597445179/m1.jpg',
                title: t('b_tab'),
                desc: t.rich('b_desc', {
                    sup: (text: string) => <sup className="sup">{text}</sup>,
                }),
            },
        ],
    };

    return (
        <div className={css.comp}>
            <EfSpec />
            <EfSwiperTab {...props} />
            <EfSpec />
        </div>
    );
}
